<template>
	<!-- @click="goToProduct(item)" -->
	<div class="product-card" @click.stop="$emit('openProductModal', item.id)">
		<div class="product-card__wrapper">
			<div class="product-card__name">
				{{ getWeaponName(item.title || item.description) }}
			</div>
			<div class="product-card__top">
				<div class="product-card__title _md">
					{{ getSkinName(item.title) }}
				</div>
				<div class="product-card__wear _md">
					({{ getWear(item.title) }})
				</div>
			</div>
		</div>
		<div class="product-card__image _ibg-contain">
			<img :src="imgDomain + item.img_url" />
		</div>
		<div class="product-card__bottom">
			<div v-if="item.old_price" class="product-card__oldPrice">
				<div class="product-card__oldPrice-number _md">
					{{ item.old_price }} {{ currencySymbol }}
				</div>
				<!--<div class="product-card__oldPrice-icon _ibg-contain">
					<img src="@/assets/images/icons/coin.svg" />
				</div>-->
			</div>
			<div class="product-card__price">
				<div class="product-card__price-number _md">
					{{ item.price }} {{ currencySymbol }}
				</div>
				<!--<div class="product-card__price-icon _ibg-contain">
					<img src="@/assets/images/icons/coin.svg" />
				</div>-->
			</div>
		</div>
		<BaseButton
			class="product-card__submit _button-white"
			@click="
				(e) => {
					e.stopPropagation();
					addToCart(item);
				}
			"
		>
			{{ $t(`Buy`) }}
		</BaseButton>
	</div>
</template>

<script>
import BaseButton, { ButtonThemes } from '@/components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ProductCard',
	components: { BaseButton },
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
		sale: {
			type: Boolean,
		},
		lastSale: {
			type: Boolean,
		},
		isListingPage: {
			type: Boolean,
		},
	},
	data() {
		return {
			imgDomain: '',
			isHovered: false,
			ButtonThemes,
		};
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	computed: {
		...mapGetters('cart', ['cartContents']),
		...mapGetters('app', ['currency']),
		...mapGetters('app', ['currencySymbol']),
		//hasDiscount() {
		//	const oldPrice = Number(
		//		this.item.old_price * this.currency.value
		//	).toFixed(2);
		//	const basePrice = Number(
		//		this.item.price * this.currency.value
		//	).toFixed(2);
		//	return oldPrice > basePrice;
		//},
	},
	methods: {
		handleClick(item) {
			this.$emit('addToCart', item);
		},
		getWeaponName(desc) {
			if (!desc) return '';
			const match = desc.match(/^([^|]+)\|/);
			return match ? match[1].trim() : '';
		},
		getSkinName(desc) {
			if (!desc) return '';
			const match = desc.match(/\|\s*([^()]+)\(/);
			return match ? match[1].trim() : '';
		},
		getWear(desc) {
			if (!desc) return '';
			const match = desc.match(/\(([^)]+)\)/);
			return match ? match[1].trim() : '';
		},
		addToCart(item) {
			if (this.isAuth) {
				const itemAlreadyInCart = this.cartContents.some(
					(cartItem) => cartItem.item_id === item.id
				);

				if (itemAlreadyInCart) {
					this.$toast.info(this.$t('This item is already in your cart.'));
					this.$emit('openCartModal');
					return;
				}

				this.$emit('addToCart', item);
				this.$emit('openCartModal');
			} else {
				this.$emit('openLoginModal');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.product-card {
	cursor: pointer;
	min-height: 100%;
	position: relative;
	@include adaptiveValue('padding-top', 25, 10);
	@include adaptiveValue('padding-left', 20, 10);
	@include adaptiveValue('padding-right', 20, 10);
	display: flex;
	flex-direction: column;
	&::before {
		content: '';
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		z-index: -1;
		border-radius: var(--border-radius-primary);
		background-color: var(--bg-card-color);
		border: 1px solid rgba(255, 255, 255, 0.1);
		@media (min-width: 649.98px) {
		}
	}
	position: relative;
	overflow: hidden;
	&::after {
		opacity: 0;
		transition: opacity 0.3s ease 0s;
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;
		background-image: url('@/assets/images/bg/yellow-blur.png');
		transform: scale(1);
		background-position: 30px 50%;
		background-repeat: no-repeat;
		background-size: contain;
	}
	@media (any-hover: hover) {
		&:hover {
			.product-card__image {
				transform: scale(1.1);
			}
			&::after {
				opacity: 1;
			}
		}
	}
	@media (min-width: 649.98px) {
		padding-bottom: 17px;
		&::before {
			height: calc(100% - 17px);
		}
	}
	@media (max-width: 649.98px) {
		&::before {
			height: 100%;
		}
	}
	&__wrapper {
		flex: 1 1 auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__name {
		font-family: var(--font-family-inter);
		font-size: 12px;
		line-height: 150%;
		color: var(--secondary-color);
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 10, 5);
		}
	}
	&__top {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
		gap: 6px;
	}
	&__title,
	&__wear {
		text-transform: capitalize;
		font-family: var(--font-family-inter);
		font-size: 18px;
	}
	&__title {
		font-weight: 700;
		@media (max-width: 649.98px) {
			font-size: 16px;
		}
	}
	&__wear {
		color: var(--secondary-color);
		@media (max-width: 649.98px) {
			font-size: 12px;
		}
	}
	&__image {
		margin-left: auto;
		margin-right: auto;
		max-width: 220px;
		width: 100%;
		padding-bottom: 44%;
		transform: scale(1);
		transition: transform 0.3s ease 0s;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 15);
		}
	}
	&__bottom {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 12);
		}
	}

	&__price,
	&__oldPrice {
		display: flex;
		align-items: center;
		gap: 6px;
		&-number {
			font-family: var(--font-family-inter);
			font-size: 18px !important;
		}
		&-icon {
			min-width: 15px;
			height: 15px;
		}
	}
	&__oldPrice {
		opacity: 0.7;
		text-decoration: line-through;
		&-number {
			font-family: var(--font-family-inter);
			font-size: 14px !important;
		}
		&-icon {
			min-width: 12px;
			height: 12px;
		}
	}
	&__submit {
		position: relative;
		z-index: var(--base-z-index);
		font-size: 16px;
		@media (min-width: 649.98px) {
			min-width: 141px;
			margin-left: auto;
			margin-right: auto;
			margin-bottom: -17px;
		}
		@media (max-width: 649.98px) {
			width: 100%;
		}
	}
}
</style>
